import * as R from "ramda";
import { getActualContentConstraintsArtefact } from "./getActualContentConstraintsArtefact.mjs";
const getConstraintsSeriesCount = R.pipe(
  getActualContentConstraintsArtefact,
  R.propOr([], "annotations"),
  R.find(
    (annot) => R.propEq("sdmx_metrics", "type", annot) && R.propEq("series_count", "id", annot)
  ),
  R.prop("title"),
  (value) => Number(value),
  R.when(isNaN, R.always(void 0))
);
export {
  getConstraintsSeriesCount
};
